(function () {
  'use strict';

  // Swiper + Fancybox
  if (typeof Fancybox !== 'undefined') {
    Fancybox.bind('[data-fancybox="gallery"]', {});
  }

  var swiper;
  if (typeof Swiper !== 'undefined') {
    swiper = new Swiper('.swiper-main', {
      loop: false,
      spaceBetween: 20,
      on: {
        slideChange: function () {
          var idx = this.activeIndex;
          document.querySelectorAll('.hc-thumb').forEach(function (t, i) {
            t.classList.toggle('is-active', i === idx);
          });
        }
      }
    });
  }

  document.querySelectorAll('.hc-thumb').forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
      if (swiper) swiper.slideTo(index);
    });
  });

  // Accordion
  document.querySelectorAll('.hc-acc__head').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var acc = btn.closest('.hc-acc');
      var container = acc.closest('.hc-accordion, .hc-faqlist');
      var isOpen = acc.classList.contains('is-open');
      if (container) {
        container.querySelectorAll('.hc-acc').forEach(function (a) {
          a.classList.remove('is-open');
          a.querySelector('.hc-acc__head').setAttribute('aria-expanded', 'false');
        });
      }
      if (!isOpen) {
        acc.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  // Variant data
  var variantMapEl = document.getElementById('hc-variant-map');
  var variants = variantMapEl ? JSON.parse(variantMapEl.textContent) : [];

  var activeFlavorChip = document.querySelector('.hc-flavorrow .hc-flavorchip.is-on');
  var activePackChip = document.querySelector('.hc-packlist .hc-packcard.is-on');
  var selected = {
    flavor: activeFlavorChip ? activeFlavorChip.dataset.value : null,
    pack: activePackChip ? activePackChip.dataset.value : null
  };

  function findVariant() {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.flavor === selected.flavor && (selected.pack === null || v.pack === selected.pack)) {
        return v;
      }
    }
    return null;
  }

  // Immediately update price div from local variant data — no AJAX/Appstle race condition
  function updatePriceDisplay(variant) {
    if (!variant) return;
    var spInput = document.querySelector('input[name="selling_plan"]');
    var isSubscription = spInput && spInput.value;

    var hasCompare = !!variant.comparePrice && variant.comparePriceCents > variant.priceCents;
    
    var regularEl = document.getElementById('hc-product-price') || document.querySelector('.hc-pricerow .hc-price:not(.appstle_subscription_final_price)');
    var nativeCompareEl = document.querySelector('.hc-pricerow .hc-price-was');
    var appstleCompareEl = document.querySelector('.hc-pricerow .price-item--regular.test2');
    var badgeEl = document.querySelector('.hc-pricerow .hc-badge-save');

    if (!isSubscription) {
      document.querySelectorAll('.hc-pricerow .appstle_subscription_final_price, .hc-pricerow .appstle_subscription_element').forEach(function(el) {
        el.remove();
      });

      if (regularEl) {
        regularEl.textContent = variant.price;
        regularEl.style.textDecoration = '';
        regularEl.removeAttribute('data-appstle-price-modified');
      }
      
      if (nativeCompareEl) {
        nativeCompareEl.style.display = hasCompare ? '' : 'none';
        if (hasCompare) nativeCompareEl.textContent = variant.comparePrice;
      }
      
      if (appstleCompareEl) appstleCompareEl.style.display = 'none';

      if (badgeEl) {
        if (hasCompare) {
          badgeEl.textContent = 'Save ' + formatMoney(variant.comparePriceCents - variant.priceCents);
          badgeEl.style.display = '';
        } else {
          badgeEl.style.display = 'none';
        }
      }
    }
  }

  function applyVariant(variant) {
    if (!variant) return;
    var hiddenInput = document.getElementById('hc-variant-id');
    if (hiddenInput) {
      hiddenInput.value = variant.id;
      if (window.history.replaceState) {
        var urlParams = new URLSearchParams(window.location.search);
        urlParams.set('variant', variant.id);
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + urlParams.toString();
        window.history.replaceState({path: newurl}, '', newurl);
      }
    }

    // Immediately update price (replaces old setTimeout DOM manipulation)
    updatePriceDisplay(variant);

    // Update dynamic accordion content (variant metafields)
    document.querySelectorAll('[data-variant-field]').forEach(function(el) {
      var field = el.getAttribute('data-variant-field');
      if (variant[field] !== undefined) {
        // Shopify metafield_tag outputs a complete HTML string or nothing.
        // We set innerHTML to either the metafield content or empty string.
        el.innerHTML = variant[field] || '';
      }
    });

    var atcBtn = document.querySelector('.hc-atc');
    if (atcBtn) atcBtn.textContent = 'Add to cart · ' + variant.price;
    var stickyPrice = document.querySelector('.hc-sticky__info strong');
    if (stickyPrice) stickyPrice.textContent = variant.price;

    if (swiper) {
      var slides = document.querySelectorAll('.swiper-main .swiper-slide');
      var targetIndex = -1;
      if (variant.imageId) {
        for (var si = 0; si < slides.length; si++) {
          if (slides[si].dataset.imageId === String(variant.imageId)) { targetIndex = si; break; }
        }
      }
      if (targetIndex === -1 && variant.flavor) {
        for (var fi = 0; fi < slides.length; fi++) {
          if (slides[fi].dataset.flavor === variant.flavor) { targetIndex = fi; break; }
        }
      }
      if (targetIndex >= 0) swiper.slideTo(targetIndex);
    }
  }

  function applyPackRestrictions(flavor) {
    var packCards = document.querySelectorAll('.hc-packlist .hc-packcard');
    if (!packCards.length) return;
    var isSampler = flavor === 'Sampler' || flavor === 'Variety';
    packCards.forEach(function (card) {
      var val = card.dataset.value || '';
      var hide = isSampler && (val === '12 Pack' || val === '24 Pack');
      card.style.display = hide ? 'none' : '';
      if (hide && card.classList.contains('is-on')) {
        card.classList.remove('is-on');
        selected.pack = null;
      }
    });
    if (isSampler) {
      var fourPack = document.querySelector('.hc-packlist .hc-packcard[data-value="4 Pack"]');
      if (fourPack && !fourPack.disabled) {
        packCards.forEach(function (c) { c.classList.remove('is-on'); });
        fourPack.classList.add('is-on');
        selected.pack = fourPack.dataset.value;
        var labelEl = document.getElementById('hc-pack-label');
        if (labelEl) labelEl.textContent = fourPack.dataset.value;
      }
    }
  }

  if (selected.flavor) applyPackRestrictions(selected.flavor);
  
  // Apply the selected variant on page load to update image, price, etc.
  var initialVariant = findVariant();
  if (initialVariant) {
    // Small delay to ensure Swiper is fully ready if needed
    setTimeout(function() {
      applyVariant(initialVariant);
    }, 50);
  }

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('.hc-flavorchip, .hc-packcard');
    if (!chip || chip.disabled) return;

    var group = chip.dataset.group;
    var value = chip.dataset.value;
    if (!group || !value) return;

    var rowSelector = group === 'flavor' ? '.hc-flavorrow .hc-flavorchip' : '.hc-packlist .hc-packcard';
    document.querySelectorAll(rowSelector).forEach(function (c) { c.classList.remove('is-on'); });
    chip.classList.add('is-on');
    selected[group] = value;

    var labelEl = document.getElementById(group === 'flavor' ? 'hc-flavor-label' : 'hc-pack-label');
    if (labelEl) labelEl.textContent = value;

    if (group === 'flavor') applyPackRestrictions(value);

    var variant = findVariant();

    // Update variant ID before notifying Appstle
    var hiddenVariantInput = document.getElementById('hc-variant-id');
    if (hiddenVariantInput && variant) hiddenVariantInput.value = variant.id;

    // Notify Appstle of variant change via hidden native selects
    var nativeSelect = document.getElementById(group === 'flavor' ? 'hc-flavor-native-select' : 'hc-pack-native-select');
    if (nativeSelect) {
      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    applyVariant(variant);
  });

  // COA toggle
  document.addEventListener('click', function (event) {
    if (!event.target.classList.contains('coa-toggle-btn')) return;
    var wrapper = event.target.closest('.coa-toggle-wrapper');
    if (!wrapper) return;
    var linksContainer = wrapper.querySelector('.coa-btn-wrapper');
    if (linksContainer) linksContainer.classList.toggle('coa-hidden');
  });

  // Bundle selector
  var bundleBtns = document.querySelectorAll('.hc-bundle');
  bundleBtns.forEach(function (bundle) {
    bundle.addEventListener('click', function () {
      bundleBtns.forEach(function (b) { b.classList.remove('is-on'); });
      bundle.classList.add('is-on');
      var variantId = bundle.dataset.variantId;
      var price = bundle.dataset.price;
      if (variantId) {
        var hiddenInput = document.getElementById('hc-variant-id');
        if (hiddenInput) hiddenInput.value = variantId;
      }
      var bundleCtaBtn = document.querySelector('.hc-bundlecta .btn');
      if (bundleCtaBtn && price) bundleCtaBtn.textContent = 'Add to cart · ' + price;
    });
  });

  // Sticky bar
  var stickyBar = document.querySelector('.hc-sticky');
  var heroSection = document.querySelector('.hc-hero');
  if (stickyBar && heroSection && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-show', !entries[0].isIntersecting);
    }, { threshold: 0 });
    stickyObserver.observe(heroSection);
  }

  // Toast
  function showToast(msg) {
    var toast = document.querySelector('.hc-toast');
    if (!toast) return;
    toast.querySelector('span').innerHTML = msg;
    toast.classList.add('is-show');
    setTimeout(function () { toast.classList.remove('is-show'); }, 3500);
  }

  // ATC form
  var atcForm = document.getElementById('hc-atc-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(atcForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          showToast('<strong>Added to cart</strong> — ' + (data.product_title || 'Item'));
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var countText = cart.item_count >= 100
                ? (window.cartStrings && window.cartStrings.item_99 ? window.cartStrings.item_99 : '99+')
                : String(cart.item_count);
              document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                el.textContent = countText;
              });
              document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
            });
        })
        .catch(function (err) { console.error('Cart add failed:', err); });
    });
  }

  // Sticky ATC button
  var stickyBtn = document.querySelector('.hc-sticky .btn');
  if (stickyBtn && atcForm) {
    stickyBtn.addEventListener('click', function () {
      atcForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  function syncAtcButton(price) {
    if (!price) return;
    var atcBtn = document.querySelector('.hc-atc');
    if (atcBtn) atcBtn.textContent = 'Add to cart · ' + price;
    var stickyPrice = document.querySelector('.hc-sticky__info strong');
    if (stickyPrice) stickyPrice.textContent = price;
  }

  // Appstle subscription sync via selling_plan input interception
  function interceptSellingPlanInput(spInput) {
    var proto = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    Object.defineProperty(spInput, 'value', {
      configurable: true,
      get: function () { return proto.get.call(this); },
      set: function (v) {
        var prev = proto.get.call(this);
        proto.set.call(this, v);
        if (String(v) !== String(prev)) {
          if (!v) {
            // Subscription cleared — restore one-time price
            var variant = findVariant();
            if (variant) {
              updatePriceDisplay(variant);
              syncAtcButton(variant.price);
            }
          } else {
            // Subscription selected — read sub price from DOM after Appstle updates it
            setTimeout(function () {
              var salePriceEl = document.querySelector('.hc-pricerow .appstle_subscription_final_price');
              var subPrice = salePriceEl ? salePriceEl.textContent.trim() : null;
              if (subPrice) syncAtcButton(subPrice);
            }, 300);
            // Fallback for slower loads
            setTimeout(function () {
              var salePriceEl = document.querySelector('.hc-pricerow .appstle_subscription_final_price');
              var subPrice = salePriceEl ? salePriceEl.textContent.trim() : null;
              if (subPrice) syncAtcButton(subPrice);
            }, 1000);
          }
        }
      }
    });
  }

  // Robust fallback: Watch the price row for Appstle's injections to keep ATC button in sync
  var priceRowEl = document.getElementById('hc-pricerow');
  if (priceRowEl) {
    new MutationObserver(function() {
      var subPriceEl = document.querySelector('.hc-pricerow .appstle_subscription_final_price');
      if (subPriceEl && subPriceEl.textContent) {
        syncAtcButton(subPriceEl.textContent.trim());
      } else {
        var regularEl = document.getElementById('hc-product-price') || document.querySelector('.hc-pricerow .hc-price');
        if (regularEl && regularEl.textContent) {
          syncAtcButton(regularEl.textContent.trim());
        }
      }
    }).observe(priceRowEl, { childList: true, subtree: true, characterData: true });
  }

  var existingSpInput = document.querySelector('input[name="selling_plan"]');
  if (existingSpInput) {
    interceptSellingPlanInput(existingSpInput);
  } else {
    var spObserver = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        for (var n = 0; n < mutations[m].addedNodes.length; n++) {
          var node = mutations[m].addedNodes[n];
          if (node.nodeType !== 1) continue;
          var found = (node.matches && node.matches('input[name="selling_plan"]'))
            ? node
            : (node.querySelector ? node.querySelector('input[name="selling_plan"]') : null);
          if (found) {
            spObserver.disconnect();
            interceptSellingPlanInput(found);
            return;
          }
        }
      }
    });
    spObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

})();
